/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'baglass/app/plugins/MenuActionInterface',
	'react',
	'react-dom',
	'ca-content/home/caHome'
], (MenuActionInterface, React, ReactDOM, caHome) => {

	class RenameAction extends MenuActionInterface {

		constructor(context) {
			super();
			this.initialize(context);
		}

		initialize(context) {
			if (context) {
				this.glassContext = context.glassContext;
			}
		}

		isItemVisible(context) {
			const selectedContext = this.getSelectedContext(context);
			if (!selectedContext) {
				return false;
			}
			return selectedContext.permissions.includes('write');
		}

		/** 
		 * This is called from the context menus and ContextToolbar
		 */
		onSelectItem(context) {
			const options = {
				isOpen: true,
				asset: this.getSelectedContext(context),
				onRename: this.onRename.bind(this, context),
				onClose: this.remove.bind(this),
				glassContext: this.glassContext
			};

			let mountPoint = document.createElement('div');
			mountPoint.setAttribute('id', 'renameDialog');
			document.body.appendChild(mountPoint);
			ReactDOM.render(React.createElement(caHome.RenameDialog, options), mountPoint);
		}

		onRename(context, newValues) {
			if (newValues) {
				this._updateMRUEntry(newValues, context);
			}
			if (context.target.activeObject.onRename){
				context.target.activeObject.onRename();
			}
		}

		_updateMRUEntry(newValues, context) {
			const activeObject = context && context.target && context.target.activeObject;
			let selectedObject = activeObject && (activeObject.targetSelectedContext[0] || activeObject.aSelectedContext[0]);
			if (selectedObject) {
				selectedObject.defaultName = newValues.defaultName;
				selectedObject.defaultDescription = newValues.defaultDescription;
			}
			context.glassContext.getSvc('.Content').then((contentService) => {
				contentService.updateMRUEntry(selectedObject);
			});	
		}

		remove() {
			const mountPoint = document.getElementById('renameDialog');
			ReactDOM.unmountComponentAtNode(mountPoint);
			mountPoint.parentNode.removeChild(mountPoint);
		}

		/**
		 * Returns the context using the current targetSelectedCount
		 * @param {*} context 
		 */
		getSelectedContext(context) {
			const activeObject = context && context.target && context.target.activeObject;
			const object = activeObject && (activeObject.targetSelectedContext || activeObject.aSelectedContext);
			if (Array.isArray(object)) {
				if (object.length === 1) {
					return object[0];
				} else {
					return null;
				}
			}

			return context;
		}

	}

	return RenameAction;
});